import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import Translation from '../../translation/translation';

export function ServiceFittingStationNotAvailable({
    onLearnMoreClick,
}) {
    return (
        <Row className="service-fitting-station-not-available">
            <Cell side={CENTER} colSpan={3}>
                <Translation
                    tagName="div"
                    className="service-fitting-station-not-available__headline sidebar__row-headline"
                    translationKey="pdp-sidebar-service-fitting-station-not-available-headline"
                />

                <div className="service-fitting-station-not-available__text">
                    <Translation
                        translationKey="pdp-sidebar-service-fitting-station-not-available-text"
                    />

                    <Translation
                        className="service-fitting-station-not-available__learn-more"
                        onClick={onLearnMoreClick}
                        translationKey="pdp-sidebar-service-fitting-station-not-available-learn-more"
                    />
                </div>

                <div className="service-fitting-station-not-available__find-station">
                    <Translation
                        tagName="button"
                        className="service-fitting-station-not-available__find-station-button"
                        disabled={true}
                        translationKey="pdp-sidebar-service-fitting-station-not-available-find-station"
                    />
                </div>
            </Cell>
        </Row>
    );
}

ServiceFittingStationNotAvailable.propTypes = {
    onLearnMoreClick: PropTypes.func.isRequired,
};
